//export const AUTH_BASE_URL = 'http://localhost:5000/auth/'
//export const ANALYTICS_BASE_URL = 'http://localhost:5000/analytics/v1/'
export const AUTH_TOKEN_KEY = 'CorToken'
export const AUTH_ADMIN_KEY = 'CorToken-A'
export const LATEST_FEEDS_STATE = 'CorLatestFeed'


export const REGULATORS = {
    us: {
        title: 'Americas',
        code: 'Americas',
        regs: ['CFPB', 'CFTC', 'DOJ', 'FDIC', 'FED', 'FinCEN', 'FINRA', 'NYDFS', 'NYSE', 'OCC', 'OFAC', 'OSC', 'OSFI', 'SEC']
    },
    sa: {
        title: 'South America',
        code: 'South America',
        regs: []
    },
    eu: {
        title: 'Europe',
        code: 'Europe',
        regs: ['ACPR', 'AFM', 'AMF', 'BaFin', 'CBI', 'DNB', 'EBA', 'ECB', 'EIOPA', 'ESMA', 'FCA', 'FSMA', 'ICO', 'IDPC', 'LU', 'PRA', 'PSR', 'SFO',]
    },
    asiapac: {
        title: 'APAC',
        code: 'APAC',
        regs: ['APRA', 'ASIC', 'AUSTRAC', 'HKMA', 'MAS', 'SFC']
    },
    africa: {
        title: 'Middle East & Africa',
        code: 'Middle East & Africa',
        regs: ['DFSA', 'FSB', 'SARB']
    },
    global: {
        title: 'Global',
        code: 'Global',
        regs: ['BIS', 'FATF', 'IOSCO']
    }
}

export const ROLES = {
    adminAccess: 'ADMIN',
    legalAnalystWorkflow: 'COR-WORKFLOW',
    relevanceAccess: 'COR-RELEVANCE',
    riskScores: 'RISK-SCORES',
    textAnalyticsAccess: 'COR-TEXT',
    complianceTracker: 'TRACKER',
    workflowAdmin: 'COR-WFADMIN',
    workflowSuper: 'WORKFLOW-SUPER',
    workflowUser: 'WORKFLOW-USER',
    RegulatoryInbox: 'REG-INBOX',
    ServiceLineView: 'SL-VIEW+SEARCH',
    ServiceLineEditor: 'SL-EDITOR',
    ServiceLineAlerts: 'SL-ALERTS',
    RegCategoryView: 'RC-VIEW+SEARCH',
    RegCategoryEditor: 'RC-EDITOR',
    RegCategoryAlerts: 'RC-ALERTS',
    VisualQuery: 'VISUAL-QUERY',
    ClientUsageReport: 'CLIENT-USE-REP',
    modelMaintenance: 'MODEL-MAINT',
    modelProduction: 'MODEL-PROD',
    regulationTags: 'REG-TAG',
    riskAssessment: 'REG-ASSESS',
    regMonitoring: 'REGMONITORING',
    alerting: 'ALERTING',
    riskApps: 'RISK-APPS',
    regVersions: 'REG-VERSION',
    autoTranslate: 'AUTO-TRANSLATE',
    ThemeView: 'THEMES-VIEW',
    themesEdit: 'THEMES-EDIT',
    DashboardAdmin: 'DASHBOARD-ADMIN',
    watchlistAccess: 'REG-WATCH',
    regPublish: 'REG-PUBLISH',
    regMakePublic: 'REG-MAKE-PUBLIC',
    regPublishToStaging: 'REG-PUB-STAGING',
    regPublishToProduction: 'REG-PUB-PROD',
    workflowClientAdmin: 'WF-CLIENTADMIN',
    routingRuleSelfServeSuper: 'SELFSERVE-SUPER',
    routingRuleSelfServeUser: 'SELFSERVE-USER',
    noticeQueues: 'NOTICE-QUEUES',
    clientTaxonomyEdit: 'TAXONOMY-EDIT',
    clientTaxonomy: 'CLIENT-TAXONOMY',
    taxonomyAdmin: 'TAXONOMY-ADMIN',
    finraUser: 'FINRA-USER',
    finraAdmin: 'FINRA-ADMIN',
    finraVis: 'FINRA-VIS',
    esgDash: 'ESG-DASH',
    pushApiAccess: 'PUSH-API-DASH',
    metaDataAccess: 'META-DATA',
    documentExport: 'DOC-EXPORT',
    summaryAccess: 'SUMMARIES'
}

export const DOCUMENT_TYPES = [
    {
        name: 'Regulatory Developments',
        items: [
            { name: 'Consultation', id: 'Consultation', checked: false },
            { name: 'Guidance', id: 'Guidance', checked: false },
            { name: 'Policy', id: 'Policy', checked: false },
            { name: 'Regulation', id: 'Regulation', checked: false },
            { name: 'Standard', id: 'Standard', checked: false },
            { name: 'Statement', id: 'Statement', checked: false }
        ]
    },
    {
        name: 'Corporate Communications',
        items: [
            { name: 'Press Release', id: 'Press Release', checked: false },
            { name: 'Business Plan', id: 'Business Plan', checked: false },
            { name: 'Speech', id: 'Speech', checked: false },
            { name: 'Report', id: 'Report', checked: false },
            { name: 'Warning', id: 'Warning', checked: false },
            { name: 'Parliamentary Commentary', id: 'Parliamentary Commentary', checked: false },
        ]
    },
    {
        name: 'Enforcements',
        items: [
            { name: 'Enforcement', id: 'Enforcement', checked: false },
            { name: 'Industry Letter', id: 'Industry Letter', checked: false }
        ]
    }
];


export const TinyMCEoptions = {
    height: 300,
    browser_spellcheck: true,
    plugins: "lists spellchecker link paste",
    paste_as_text: true,
    branding: false,
    menubar: false,
    link_context_toolbar: true,
    toolbar: 'undo redo | bold italic underline strikethrough superscript subscript | formatselect | fontsizeselect | fontselect | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link',
    block_formats: 'Normal=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6'
}

export const RichEditorOptions = { // To remove - options for draft-js
    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'link'],
    inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript']
    },
    blockType: {
        options: ['normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
    }
}


export const Currencies = [
    { "value": "AUD", "label": "AUD" },
    { "value": "CAD", "label": "CAD" },
    { "value": "EUR", "label": "EUR" },
    { "value": "GBP", "label": "GBP" },
    { "value": "HKD", "label": "HKD" },
    { "value": "SGD", "label": "SGD" },
    { "value": "USD", "label": "USD" }
]


// WEBPACK FOOTER //
// ./src/constants.js